import { Box, Divider, Link, Sheet, Stack, Typography } from "@mui/joy";
import { motion } from "framer-motion";

export default function Footer() {
  const links = [
    { label: "О компании", href: "#" },
    { label: "Услуги", href: "#" },
    { label: "Контакты", href: "#" },
    { label: "Политика конфиденциальности", href: "#" },
  ];

  return (
    <Sheet
      component="footer"
      variant="outlined"
      sx={{
        borderLeft: "none", borderRight: "none", borderBottom: "none",
        px: { xs: 2, sm: 4 }, py: { xs: 3, sm: 4 },
        background: "linear-gradient(180deg, var(--joy-palette-background-body) 0%, var(--joy-palette-background-level1) 100%)",
      }}
    >
      <Box sx={{ maxWidth: 900, mx: "auto" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
          spacing={2}
        >
          {/* Brand */}
          <Stack direction="row" alignItems="center" spacing={1.5}>
                <motion.div
                    whileHover={{ rotate: [-5, 5, -3, 0] }}
                    transition={{ duration: 0.4 }}
                    style={{ display: 'flex',  }}
                >
                    <Sheet
                        component={"img"}
                        src='/logo.png'
                        alt='Planium'
                        sx={{
                        width: 38, height: 38
                        }}
                    />
                </motion.div>
                <Box>
                    <Typography level="title-sm" fontWeight={800} sx={{ letterSpacing: "-0.3px" }}>PLANIUM</Typography>
                    <Typography level="body-xs" color="neutral" sx={{ mt: -0.2 }}>Ваш персональный замер!</Typography>
                </Box>
            </Stack>

          {/* Links */}
          <Stack direction="row" flexWrap="wrap" gap={1.5}>
            {links.map(l => (
              <Typography
                key={l.label}
                component="a"
                href={l.href}
                level="body-xs"
                color="neutral"
                sx={{ textDecoration: "none", "&:hover": { color: "primary.500" }, transition: "color 0.2s" }}
              >
                {l.label}
              </Typography>
            ))}
          </Stack>
        </Stack>

        <Divider sx={{ my: 2 }} />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
          spacing={1}
        >
          <Typography level="body-xs" color="neutral">
            © {new Date().getFullYear()} PLANIUM. Все права защищены.
          </Typography>
          <Stack direction={{ xs: 'column', sm: "row" }} sx={{ gap: 0.5 }}>
            <Typography level="body-xs" color="neutral">
              ivanov.hse@mail.ru
            </Typography>
            <Typography level="body-xs" color="neutral">
              ИП Иванов Ю.В
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Sheet>
  );
}
